import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {GetDocumentsResult} from '../types/GetDocumentsResult';


export const useGetDocuments = () => {

	const { data, isLoading } = useQuery({
		queryKey: ['documents'],
		queryFn: async () => await apiClient.get('document/documents') as GetDocumentsResult
	});

	return {
		data,
		isLoading
	};
};
